import { AbstractScatterVisualization } from './../visualization.abstract.scatter.component';
export class TruncatedSvdGraph extends AbstractScatterVisualization {
}
